/**
 * FormaTopBar — the thin black `AUTODESK Forma` bar that sits above
 * every Forma surface. Cosmetic; matches the SVG mockup's top 28px.
 */
import { TopChrome } from "../TopChrome";
import { FORMA } from "./FormaTokens";

export function FormaTopBar() {
  return (
    <div
      style={{
        height: 28,
        background: FORMA.topBarBg,
        display: "flex",
        alignItems: "center",
        padding: "0 12px",
        color: "#fff",
        fontSize: 12,
        gap: 16,
        flexShrink: 0,
      }}
    >
      <strong style={{ letterSpacing: 0.3 }}>AUTODESK</strong>
      <span style={{ fontWeight: 500 }}>Forma</span>
      <div style={{ marginLeft: "auto" }}>
        <TopChrome />
      </div>
    </div>
  );
}
